import api from './api';

/**
 * Service for managing project operations
 */

export const projectService = {
  /**
   * Get project details
   */
  async getProject(projectId) {
    const result = await api.composerGetProject(projectId);
    if (result?.error) throw new Error(result.error);
    return result.item || result;
  },

  /**
   * Update project context and settings
   */
  async updateProject(projectId, payload) {
    const result = await api.composerUpdateProject(projectId, payload);
    if (result?.error) throw new Error(result.error);
    return result;
  },

  /**
   * List all projects
   */
  async listProjects() {
    const result = await api.composerListProjects();
    return Array.isArray(result?.items) ? result.items : (Array.isArray(result) ? result : []);
  },

  /**
   * Save project context
   */
  async saveProjectContext(projectId, contextData) {
    const normalizeJoined = (val, sep) => {
      if (Array.isArray(val)) return val.map((s) => String(s ?? '').trim()).filter(Boolean).join(sep);
      if (typeof val === 'string') return val;
      return '';
    };
    const normalizeFiles = (val) => {
      if (Array.isArray(val)) return val;
      if (typeof val === 'string') return val.split(/\n+/).map((s) => s.trim()).filter(Boolean);
      return [];
    };

    const payload = {
      context: normalizeJoined(contextData?.context, '\n'),
      contextFiles: normalizeFiles(contextData?.contextFiles),
      goals: normalizeJoined(contextData?.goals, ', ')
    };
    
    return this.updateProject(projectId, payload);
  }
};

export default projectService;
